import { Button, Card, Checkbox, Collapse, CollapseProps, ConfigProvider, Form, Image, Input, message, Radio, Spin, Typography } from "antd";
import React, { useEffect, useState } from "react";
import Logo from "../../../../assets/images/Logo_250.png";
import { useForm } from "antd/es/form/Form";
import { CaretUpOutlined, CaretDownOutlined, EnvironmentOutlined, ArrowRightOutlined, ClockCircleOutlined } from "@ant-design/icons";
import "../../css/index.css";
import { useId24 } from "../../../../drivers/id24/Id24Provider";
import { loadAppConfig } from "../../../../configs/app-config";
import { UserEventService } from "../../../../api/user.service";
import { AgendaUrlService } from "../../../../api/agenda.service";

import { useNavigate, useParams } from "react-router-dom";

export const EconnectSelectSection: React.FC = (): React.ReactElement => {
  const { id24Axios } = useId24();
  const apiBaseUrl = id24Axios(loadAppConfig().REACT_APP_API_BASE_URL);
  const [formValue] = useForm();
  const [loading, setLoading] = useState<boolean>(true);
  const { agendaid, ticketid } = useParams<{ agendaid: string; ticketid: string }>();
  const [agenda, setAgenda] = useState<any>([]);
  const navigate = useNavigate();
  const [userData, setUserDate] = useState<{
    userId: "";
    numberId: string;
    dataSource: {
      fullname: string;
      position: string;
      company: string;
      businessEmail: string;
      phoneNumber: string;
      businessType: {
        value: string;
        label: string;
      };
      type: string;
      ticketNumber: string;
    };
  }>({
    userId: "",
    numberId: "",
    dataSource: {
      fullname: "",
      position: "",
      company: "",
      businessEmail: "",
      phoneNumber: "",
      businessType: {
        value: "",
        label: "",
      },
      type: "",
      ticketNumber: "",
    },
  });
  const [activeKeys, setActiveKeys] = useState<string[]>([]);

  useEffect(() => {
    if (loading) {
      featchData();
    }
  }, [loading]);

  const mockData = [
    {
      key: "S1",
      label: "15:30 - 16:15",
      children: [
        {
          value: "L2",
          label: "The Harmony, Level 2",
          detail: "Opportunities and Challenges in Smart City Management with AI Technologies",
        },
        {
          value: "L3",
          label: "Focus I&II, Level 3",
          detail: "Transform into a Customer-Centric Company through Customer Experience Management",
        },
        {
          value: "S4",
          label: "Energize I&II, Level 4",
          detail: "BoringOps : Cloud Transformation",
        },
      ],
    },
    {
      key: "S2",
      label: "16:15 - 16:30",
      children: [
        {
          value: "L2",
          label: "The Harmony, Level 2",
          detail: "Technology Updates for a Smart, Livable and Resilient City Toward 2030",
        },
      ],
    },
    {
      key: "S3",
      label: "16:15 - 17:00",
      children: [
        {
          value: "L3",
          label: "Focus I&II, Level 3",
          detail: "From Data to Impact: Driving Sustainability with AI and Data Governance",
        },
        {
          value: "L4",
          label: "Energize I&II, Level 4",
          detail: "Become Part of the OSD Family",
        },
      ],
    },
    {
      key: "S3",
      label: "16:30 - 17:00",
      children: [
        {
          value: "L2",
          label: "The Harmony, Level 2",
          detail: "Intelligent Sustainability: Leveraging AIoT for Enhanced ESG Performance",
        },
      ],
    },
  ];

  const featchData = async () => {
    if (agendaid && ticketid) {
      const user = await UserEventService(apiBaseUrl).getByEventAndTicket(agendaid, ticketid);
      const agenda = await AgendaUrlService(apiBaseUrl).getOne(agendaid);
      if (agenda.length > 0) {
        setActiveKeys(agenda[0].agendaDetail.map((item: any) => `${item.key}`));
        setAgenda(agenda);
      }
      if (user && user.dataSource.section) {
        const section = user.dataSource.section;
        [section].forEach((item: any) => {
          Object.entries(item).forEach(([key, value]) => {
            formValue.setFieldValue(key, value);
          });
        });
      }
      setUserDate(user);
      setLoading(false);
    }
  };

  const items: CollapseProps["items"] =
    agenda !== undefined && agenda.length > 0
      ? agenda[0].agendaDetail.map((item: any) => ({
          key: item.key,
          label: (
            <div
              className="flex justify-between items-center p-3 rounded-lg text-gray-800 font-semibold"
              style={{
                background: "linear-gradient(to right, #B2E0F6, #E4C6CB)",
                borderRadius: "0px",
              }}
            >
              <div className="flex items-center gap-2">
                <ClockCircleOutlined className="text-gray-600" />
                <span> {item.label}</span>
              </div>
              {activeKeys.includes(item.key) ? <CaretUpOutlined className="text-gray-600" /> : <CaretDownOutlined className="text-gray-600" />}
            </div>
          ),
          children: (
            <Form.Item name={`${item.key}`}>
              <Radio.Group>
                <div className="flex flex-col space-y-2">
                  {item.children.map((session: any) => (
                    <>
                      <Radio key={session.value} value={session.value} className="text-gray-700">
                        <div className="flex items-center gap-2">
                          <EnvironmentOutlined className="text-blue-600" />
                          <span className="font-bold">
                            {session.label.split(",")[0]}, {session.label.split(",")[1]}
                          </span>
                        </div>
                        {session.detail}
                      </Radio>
                    </>
                  ))}
                </div>
              </Radio.Group>
            </Form.Item>
          ),
          showArrow: false,
        }))
      : [];

  const onFinish = async (event: any) => {
    const data = { ...userData.dataSource, section: event };
    try {
      if (agendaid) {
        await UserEventService(apiBaseUrl).updateByEvent(userData.userId, data);
        if (userData.dataSource.type === "V") {
          navigate(`/activity-agenda/select-section/${agendaid}/dinner/${ticketid}`);
        } else {
          navigate(`/activity-agenda/select-section/${agendaid}/success-dinner`);
        }
        setLoading(true);
      }
    } catch (err) {
      console.log(err);
    }
  };

  const handleCollapseChange = (keys: string | string[]) => {
    setActiveKeys(typeof keys === "string" ? [keys] : keys);
  };

  return (
    <>
      <Spin tip="Loading..." spinning={loading}>
        <Card className="flex justify-center p-2">
          <Form form={formValue} layout="vertical" autoComplete="off" className="w-full" onFinish={onFinish}>
            <div className="flex justify-center pb-[20px]">
              <Image src={Logo} width={150} preview={false} />
            </div>
            <div className="text-center mt-[5px]">
              <Typography className="font-bold w-full text-[rgba(84,86,90,1)]">{`Select Your Breakout Sessions`}</Typography>
            </div>
            <br />
            <div className=" pb-4">Available Sessions:*</div>
            <Collapse
              bordered={false}
              items={items}
              expandIconPosition={"end"}
              activeKey={activeKeys}
              onChange={handleCollapseChange}
              className="bg-white"
              //   defaultActiveKey={dataMock.map((item)=>`${item.key}`)}
              //   style={{ borderRadius: "0px", padding: "0px" }}
            />
            <br />
            <br />
            <br />
            <Form.Item>
              <div className="w-[300px]">
                <Button htmlType="submit" type="primary" className="text-white bg-[rgba(10,78,136,1)] w-full rounded-[5px]" size="large">
                  {userData.dataSource.type === "V" ? (
                    <>
                      Next <ArrowRightOutlined />
                    </>
                  ) : (
                    <>
                      Confirm <ArrowRightOutlined />
                    </>
                  )}
                </Button>
              </div>
            </Form.Item>
          </Form>
        </Card>
      </Spin>
    </>
  );
};
